export const Setup = {
    //endpoint: "https://api-test.digimaall.com",
    endpoint:window.location.origin+"/api",
    payment_endpoint: "https://test.mobank.co",
    file_endpoint: "https://test-loyalty-minio.darkube.app/loyalty-media",
    version: "v1",
    default_malls: "MxaeJ3UvbW",
    mqtt: "wss://chat-test.digimaall.com:443"
}
